<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import ViewerPill from '@/components/bop/ViewerPill.vue'

defineProps<{
  factor: number
}>()

const emit = defineEmits<{
  explode: [factor: number]
  end: []
  reset: []
}>()

const { t } = useI18n()
</script>

<template>
  <viewer-pill class="viewer-explode">
    <v-icon size="18" color="grey-darken-2">open_in_full</v-icon>
    <span class="viewer-explode__label">{{ t('component.bopModelViewer.explode') }}</span>
    <v-slider
      :model-value="factor"
      :min="0"
      :max="3.5"
      :step="0.05"
      hide-details
      density="compact"
      color="primary"
      class="viewer-explode__slider"
      :title="t('component.bopModelViewer.autoExplode')"
      @update:model-value="(value: number) => emit('explode', value)"
      @end="emit('end')"
    />
    <v-btn
      icon
      size="small"
      variant="text"
      color="grey-darken-2"
      :title="t('component.bopModelViewer.resetTransforms')"
      @click="emit('reset')"
    >
      <v-icon>restart_alt</v-icon>
    </v-btn>
  </viewer-pill>
</template>

<style scoped>
.viewer-pill.viewer-explode {
  gap: 8px;
  padding: 2px 8px;
}

.viewer-explode__label {
  font-size: 0.8em;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.7);
}

.viewer-explode__slider {
  width: 110px;
}
</style>
